import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { Link } from '@skatteetaten/ds-buttons';
import { B as BreadcrumbsItemContext } from '../BreadcrumbsItemContext.esm.js';

const BreadcrumbsLink = /*#__PURE__*/ forwardRef(({ href, children, ...rest }, ref)=>{
    const { displayAsCurrentPage } = useContext(BreadcrumbsItemContext);
    if (displayAsCurrentPage) {
        return /*#__PURE__*/ jsx("span", {
            ref: ref,
            ...rest,
            children: children
        });
    }
    return /*#__PURE__*/ jsx(Link, {
        ref: ref,
        href: href,
        ...rest,
        children: children
    });
});
BreadcrumbsLink.displayName = 'BreadcrumbsLink';

export { BreadcrumbsLink };
